module.exports = __webpack_public_path__ + "static/media/mother-me.72ec687a.png";